import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, withCtx as _withCtx, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-24313e12"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "doctorInfoPopup",
  class: "popup-vue"
}
const _hoisted_2 = { class: "popup-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "body-title" }, [
  /*#__PURE__*/_createElementVNode("h1", null, "의료진 정보"),
  /*#__PURE__*/_createElementVNode("p", null, "선택한 의료진 정보입니다.")
], -1))
const _hoisted_4 = {
  key: 0,
  class: "status-confirm-wrap"
}
const _hoisted_5 = {
  key: 0,
  class: "status-wrap"
}
const _hoisted_6 = { class: "status-button-vue" }
const _hoisted_7 = {
  key: 1,
  class: "status-wrap"
}
const _hoisted_8 = { class: "status-button-vue" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", null, "* 승인하시겠습니까?", -1))
const _hoisted_10 = { class: "" }
const _hoisted_11 = {
  key: 0,
  class: "info-exception-layer"
}
const _hoisted_12 = { class: "err-server" }
const _hoisted_13 = { class: "err-server-msg" }
const _hoisted_14 = {
  key: 1,
  id: "doctorInfo",
  class: "popup-content"
}
const _hoisted_15 = { class: "content-left regist-info1" }
const _hoisted_16 = { action: "" }
const _hoisted_17 = { class: "" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sub-title" }, "기본 정보", -1))
const _hoisted_19 = { class: "input-item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "doctorName" }, "이름", -1))
const _hoisted_21 = { class: "input-item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "id" }, "아이디(이메일)", -1))
const _hoisted_23 = { class: "input-item" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "metaverseUrl" }, "메타버스 계정", -1))
const _hoisted_25 = { class: "input-item nationality" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "nationality" }, "국가", -1))
const _hoisted_27 = { class: "options-wrap search-wrap" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "input-item medical-subject-kr" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "전문 진료과목", -1))
const _hoisted_31 = {
  key: 0,
  class: "options-wrap"
}
const _hoisted_32 = { class: "options" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = { class: "input-item medical-disease-kr" }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "하위 진료질환", -1))
const _hoisted_36 = {
  key: 0,
  class: "options-wrap"
}
const _hoisted_37 = { class: "options" }
const _hoisted_38 = ["onClick"]
const _hoisted_39 = {
  key: 0,
  class: "option-results"
}
const _hoisted_40 = ["onClick"]
const _hoisted_41 = { class: "input-item" }
const _hoisted_42 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "licenseNumber" }, "의료진 면허번호", -1))
const _hoisted_43 = { class: "input-item" }
const _hoisted_44 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "licenseImage" }, "의료진 면허 & 여권 사진", -1))
const _hoisted_45 = {
  class: "label-file",
  for: "licenseImage"
}
const _hoisted_46 = { class: "file-box" }
const _hoisted_47 = { class: "thumbnail" }
const _hoisted_48 = ["src"]
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-attatch hidden-font" }, "사진 첨부", -1))
const _hoisted_50 = { class: "img-preview" }
const _hoisted_51 = ["src"]
const _hoisted_52 = { key: 1 }
const _hoisted_53 = { class: "input-item" }
const _hoisted_54 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "profileImage" }, "의료진 프로필 사진", -1))
const _hoisted_55 = {
  class: "label-file",
  for: "profileImage"
}
const _hoisted_56 = { class: "file-box" }
const _hoisted_57 = { class: "thumbnail" }
const _hoisted_58 = ["src"]
const _hoisted_59 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "btn-attatch hidden-font" }, "사진 첨부", -1))
const _hoisted_60 = { class: "img-preview" }
const _hoisted_61 = ["src"]
const _hoisted_62 = { key: 1 }
const _hoisted_63 = { class: "right-wrap" }
const _hoisted_64 = { class: "content-right regist-info2" }
const _hoisted_65 = { class: "lang-tabs" }
const _hoisted_66 = { class: "lang-content info2-en" }
const _hoisted_67 = { action: "" }
const _hoisted_68 = { class: "" }
const _hoisted_69 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sub-title" }, "추가 정보", -1))
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "lang-tabs" }, [
  /*#__PURE__*/_createElementVNode("button", { class: "lang-tab-en on" }, "영어")
], -1))
const _hoisted_71 = { class: "input-item" }
const _hoisted_72 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affiliationEn" }, "Affiliated hospital", -1))
const _hoisted_73 = { class: "input-item" }
const _hoisted_74 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "activityEn" }, "Activity/Press report", -1))
const _hoisted_75 = { class: "input-item" }
const _hoisted_76 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "educationEn" }, "Education/Career", -1))
const _hoisted_77 = {
  key: 0,
  class: "lang-content info2-kr"
}
const _hoisted_78 = { class: "" }
const _hoisted_79 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sub-title" }, "추가 정보(한국어)", -1))
const _hoisted_80 = { class: "input-item" }
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affiliaitionKr" }, "소속", -1))
const _hoisted_82 = { class: "input-item" }
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "activityKr" }, "학술활동/언론보도", -1))
const _hoisted_84 = { class: "input-item" }
const _hoisted_85 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "학력/경력", -1))
const _hoisted_86 = {
  key: 1,
  class: "lang-content info2-ru"
}
const _hoisted_87 = { action: "" }
const _hoisted_88 = { class: "" }
const _hoisted_89 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", { class: "sub-title" }, "추가 정보(러시아어)", -1))
const _hoisted_90 = { class: "input-item" }
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "affiliationRu" }, "Аффилированная госпиталь", -1))
const _hoisted_92 = { class: "input-item" }
const _hoisted_93 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Отчет об активности/Для прессы", -1))
const _hoisted_94 = { class: "input-item" }
const _hoisted_95 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Образование/карьера", -1))
const _hoisted_96 = {
  key: 0,
  class: "currentPopup"
}
const _hoisted_97 = {
  key: 0,
  class: "resultPopup"
}
const _hoisted_98 = {
  key: 2,
  class: "list-loading-layer"
}
const _hoisted_99 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "list-loading" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "dots" }, [
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span"),
    /*#__PURE__*/_createElementVNode("span")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "msg" }, "조회중..")
], -1))
const _hoisted_100 = [
  _hoisted_99
]
const _hoisted_101 = { class: "popup-bottom" }
const _hoisted_102 = { class: "btn-confirm-wrap" }

import { onBeforeMount, onMounted, watch } from 'vue';
import { computed, ref } from '@vue/reactivity';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';

import StatusButton from '@/components/button/StatusButton.vue';
import ExceptionPopup from '@/components/popup/ExceptionPopup.vue';
import ResultPopup from '@/components/popup/ResultPopup.vue';

export default /*#__PURE__*/_defineComponent({
  __name: 'DoctorInfoPopup',
  props: {
  popupTitle: {
    type: String,
    required: false,
  },
  currentDoctor: {
    type: Object,
    required: true,
  },
},
  emits: ['onClick_close'],
  setup(__props, { emit }) {

const props = __props;

const store = useStore();
const router = useRouter();
const Dr = store.state.moduleDr;
let doctorInfo = computed(() => Dr.doctorInfo);


/**** popup ------------------- */
var currentPopup = ref(null);
var popupTitle = ref('');
var popupDesc = ref('');
var exception = computed(() => Dr.exception);
var result = computed(() => Dr.result);
let onCallMethod = () => {
  return console.log('on call');
};
const close_currentPopup = () => {
  currentPopup.value = null;
};
const close_resultPopup = async () => {
  store.commit('moduleDr/reset_result', { root: true });
  router.go(0);
};
const onClick_cancel = () => {
  close_currentPopup();
};
const onClick_close = () => {
  close_currentPopup();
};
const onClick_confirm = async () => {
  close_currentPopup();
  onCallMethod();
};
/**** data -------------------- */
var nationalityList = computed(() => Dr.nationalityList);
var nationalityList_name = computed(() => store.getters['moduleDr/getNationalityList_name']);
var isOn_nationality_option = ref(false);
var selectedDisease_name = '진료질환 선택';
var selectedSubject_name = '진료과목 선택';
var subjects = computed(() => Dr.subjects);
var diseases_onSubject = computed(() => Dr.diseases_onSubject);
var nationality_result = ref({});
var subject_result = ref(null);
var diseases_result = ref([]);
var regSubjectCodes = ref([]);
var isOn_nationality_result = ref(false);
var isOn_diseases_result = ref(true);
var isValid = ref({
  doctorName: false,
  doctorEmail: false,
  metaverseUrl: true,
  nationality: false,
  diseases: true,
  licenseNumber: false,
  licenseImage: false,
  profileImage: false,
  affiliationEn: false,
  activityEn: false,
  educationEn: false,
  affiliationKr: true,
  activityKr: true,
  educationKr: true,
  affiliationRu: true,
  activityRu: true,
  educationRu: true,
});
var validMsg = ref({
  doctorName: `필수 입력 사항`,
  doctorEmail: `필수 입력 사항`,
  metaverseUrl: `선택 입력 사항`,
  nationality: `필수 입력 사항`,
  diseases: `선택 입력 사항`,
  licenseNumber: `필수 입력 사항`,
  licenseImage: `필수 입력 사항`,
  profileImage: `필수 입력 사항`,
  affiliationEn: `필수 입력 사항`,
  activityEn: `필수 입력 사항`,
  educationEn: `필수 입력 사항`,
  affiliationKr: `선택 입력 사항`,
  activityKr: `선택 입력 사항`,
  educationKr: `선택 입력 사항`,
  affiliationRu: `선택 입력 사항`,
  activityRu: `선택 입력 사항`,
  educationRu: `선택 입력 사항`,
});
var licenseImage = ref({
  name: `.gif, .jpeg, .png (200kb 이하)`,
  type: ``,
  size: 0,
  url: ``,
  thumbnail: ``,
});
var profileImage = ref({
  name: `.gif, .jpeg, .png (200kb 이하)`,
  type: ``,
  size: 0,
  url: ``,
  thumbnail: ``,
});
/**** capsules ---------------- */
const reset_options = () => {
  isOn_nationality_option.value = false;
  isOn_subject_option.value = false;
  isOn_diseases_option.value = false;
};

/**** style ------------------- */
var isOnLoading_doctorInfo = ref(false);
var isOn_subject_option = ref(false);
var isOn_diseases_option = ref(false);

var onClick_tabKr = () => {
  isOn_tabKr.value = true;
  isOn_tabRu.value = false;
};
var onClick_tabRu = () => {
  isOn_tabKr.value = false;
  isOn_tabRu.value = true;
};
var isOn_tabKr = ref(true);
var isOn_tabRu = ref(false);

/**** methods ----------------- */
const onClick_approve = async () => {
  // console.log(props.currentDoctor.doctorSid);
  await store.dispatch('moduleDr/approveDoctorApply', props.currentDoctor.doctorSid, { root: true });
  emit('onClick_close');
};
const setDoctorInfo = async () => {
  isOnLoading_doctorInfo.value = true;
  store.dispatch('moduleDr/getDoctorInfo', props.currentDoctor.doctorSid, { root: true });
};
const setSubjects_result = () => {
  if (doctorInfo.value.speciality !== null && doctorInfo.value.speciality.length !== undefined && doctorInfo.value.speciality.length !== 0) {
    for (let i = 0; i < doctorInfo.value.speciality.length; i++) {
      regSubjectCodes.value.push(doctorInfo.value.speciality[i].subject.code);
    }
  } else return;
};
const setDisease_result = () => {
  if (doctorInfo.value.speciality !== null && doctorInfo.value.speciality.length !== undefined && doctorInfo.value.speciality.length !== 0) {
    for (let i = 0; i < doctorInfo.value.speciality.length; i++) {
      for (let j = 0; j < doctorInfo.value.speciality[i].disease_list.length; j++) {
        diseases_result.value.push(doctorInfo.value.speciality[i].disease_list[j]);
      }
    }
  } else return;
};
const setNationalityList = () => {
  const word = ``;
  store.dispatch('moduleDr/getNationalityList', word, { root: true });
};
const checkValid_doctorName = async () => {
  let reg_doctorName = /^(?=.{3,40}$).*/;
  if (doctorInfo.value.doctorName === ``) {
    isValid.value.doctorName = false;
    validMsg.value.doctorName = `필수 입력 사항`;
  } else {
    if (!reg_doctorName.test(doctorInfo.value.doctorName)) {
      isValid.value.doctorName = false;
      validMsg.value.doctorName = `3~40자의 문자만 가능합니다.`;
    } else {
      isValid.value.doctorName = true;
      validMsg.value.doctorName = `등록된 이름은 수정할 수 없습니다.`;
    }
  }
};
const checkValid_doctorEmail = async () => {
  let reg_doctorEmail = /^[a-z0-9_-].{4,20}@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/;
  if (doctorInfo.value.doctorEmail === ``) {
    isValid.value.doctorEmail = false;
    validMsg.value.doctorEmail = `필수 입력 사항`;
  } else {
    if (!reg_doctorEmail.test(doctorInfo.value.doctorEmail)) {
      isValid.value.doctorEmail = false;
      validMsg.value.doctorEmail = `5~20자의 영문 소문자, 숫자와 특수기호(_),(-)만 사용 가능합니다.`;
    } else {
      isValid.value.doctorEmail = true;
      validMsg.value.doctorEmail = `등록된 아이디(이메일)은 수정할 수 없습니다.`;
    }
  }
};
const checkValid_metaverseUrl = async () => {
  let reg_metaverseUrl = /(http(s)?:\/\/)([a-z0-9\w]+\.*)+[a-z0-9]{2,4}/gi;
  if (doctorInfo.value.metaverseUrl === `` || doctorInfo.value.metaverseUrl === `https://`) {
    isValid.value.metaverseUrl = true;
    validMsg.value.metaverseUrl = `선택 입력 사항`;
  } else {
    if (!reg_metaverseUrl.test(doctorInfo.value.metaverseUrl)) {
      isValid.value.metaverseUrl = true;
      validMsg.value.metaverseUrl = `https://로 시작하는 계정 URL를 입력하세요.`;
    } else {
      isValid.value.metaverseUrl = true;
      validMsg.value.metaverseUrl = `입력 완료`;
    }
  }
};
const checkValid_nationality = async () => {
  if (doctorInfo.value.nationality === ``) {
    isValid.value.nationality = false;
    validMsg.value.nationality = `필수 입력 사항`;
  } else {
    if (nationalityList_name.value.indexOf(doctorInfo.value.nationality) !== -1) {
      isValid.value.nationality = true;
      validMsg.value.nationality = `입력 완료`;
    } else {
      isValid.value.nationality = false;
      validMsg.value.nationality = `일치하는 국가명이 없습니다.`;
    }
  }
};
const checkValid_diseases = async () => {
  if (doctorInfo.value.speciality.length === 0) {
    isValid.value.diseases = true;
    validMsg.value.diseases = `선택 입력 사항`;
  } else {
    isValid.value.diseases = true;
    validMsg.value.diseases = `입력 완료`;
  }
};
const checkValid_licenseNumber = async () => {
  if (doctorInfo.value.licenseNumber === ``) {
    isValid.value.licenseNumber = false;
    validMsg.value.licenseNumber = `면허번호를 입력해 주세요.`;
  } else {
    isValid.value.licenseNumber = true;
    validMsg.value.licenseNumber = `입력 완료`;
  }
};
const checkValid_licenseImage = async () => {
  if (doctorInfo.value.licenseImage === null) {
    isValid.value.licenseImage = false;
    validMsg.value.licenseImage = `필수 입력 사항`;
  } else {
    isValid.value.licenseImage = true;
    validMsg.value.licenseImage = `입력 완료`;
  }
};
const checkValid_profileImage = async () => {
  if (doctorInfo.value.profileImage === null) {
    isValid.value.profileImage = false;
    validMsg.value.profileImage = `필수 입력 사항`;
  } else {
    isValid.value.profileImage = true;
    validMsg.value.profileImage = `입력 완료`;
  }
};
const checkValid_affiliationEn = async () => {
  if (doctorInfo.value.affiliationEn === ``) {
    isValid.value.affiliationEn = false;
    validMsg.value.affiliationEn = `필수 입력 사항`;
  } else {
    isValid.value.affiliationEn = true;
    validMsg.value.affiliationEn = `입력 완료`;
  }
};
const checkValid_activityEn = async () => {
  if (doctorInfo.value.activityEn === ``) {
    isValid.value.activityEn = false;
    validMsg.value.activityEn = `필수 입력 사항`;
  } else {
    isValid.value.activityEn = true;
    validMsg.value.activityEn = `입력 완료`;
  }
};
const checkValid_educationEn = async () => {
  if (doctorInfo.value.educationEn === ``) {
    isValid.value.educationEn = false;
    validMsg.value.educationEn = `필수 입력 사항`;
  } else {
    isValid.value.educationEn = true;
    validMsg.value.educationEn = `입력 완료`;
  }
};
const checkValid_affiliationKr = async () => {
  if (doctorInfo.value.affiliationKr === `` || doctorInfo.value.affiliationKr === null) {
    isValid.value.affiliationKr = true;
    validMsg.value.affiliationKr = `선택 입력 사항`;
  } else {
    isValid.value.affiliationKr = true;
    validMsg.value.affiliationKr = `입력 완료`;
  }
};
const checkValid_activityKr = async () => {
  if (doctorInfo.value.activityKr === `` || doctorInfo.value.activityKr === null) {
    isValid.value.activityKr = true;
    validMsg.value.activityKr = `선택 입력 사항`;
  } else {
    isValid.value.activityKr = true;
    validMsg.value.activityKr = `입력 완료`;
  }
};
const checkValid_educationKr = async () => {
  if (doctorInfo.value.educationKr === `` || doctorInfo.value.educationKr === null) {
    isValid.value.educationKr = true;
    validMsg.value.educationKr = `선택 입력 사항`;
  } else {
    isValid.value.educationKr = true;
    validMsg.value.educationKr = `입력 완료`;
  }
};
const checkValid_affiliationRu = async () => {
  if (doctorInfo.value.affiliationRu === `` || doctorInfo.value.affiliationRu === null) {
    isValid.value.affiliationRu = true;
    validMsg.value.affiliationRu = `선택 입력 사항`;
  } else {
    isValid.value.affiliationRu = true;
    validMsg.value.affiliationRu = `입력 완료`;
  }
};
const checkValid_activityRu = async () => {
  if (doctorInfo.value.activityRu === `` || doctorInfo.value.activityRu === null) {
    isValid.value.activityRu = true;
    validMsg.value.activityRu = `선택 입력 사항`;
  } else {
    isValid.value.activityRu = true;
    validMsg.value.activityRu = `입력 완료`;
  }
};
const checkValid_educationRu = async () => {
  if (doctorInfo.value.educationRu === `` || doctorInfo.value.educationRu === null) {
    isValid.value.educationRu = true;
    validMsg.value.educationRu = `선택 입력 사항`;
  } else {
    isValid.value.educationRu = true;
    validMsg.value.educationRu = `입력 완료`;
  }
};
const onClick_nationality_box = () => {
  if (!isOn_nationality_option.value) {
    isOn_nationality_option.value = true;
  } else {
    isOn_nationality_option.value = false;
  }
};
const onClick_nationality = async (item: object) => {
  reset_options();
  isOn_nationality_result.value = false;
  nationality_result.value = ``;
  setTimeout(() => {
    nationality_result.value = item;
    doctorInfo.value.nationality = item.countryName;
    isOn_nationality_result.value = true;
  }, 200);
};
const onClick_subjects_box = () => {
  setTimeout(() => {
    if (isOn_subject_option.value) {
      reset_options();
      subject_result.value = null;
      selectedSubject_name = '진료과목 선택';
    } else {
      reset_options();
      isOn_subject_option.value = true;
    }
  }, 200);
};
const onClick_diseases_onSubject_box = () => {
  reset_options();
  if (subject_result.value === null) {
    popupTitle.value = '진료질환 선택';
    popupDesc.value = '진료과목을 먼저 선택해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    if (diseases_onSubject.value.length > 0) {
      setTimeout(() => {
        if (isOn_diseases_option.value) {
          isOn_diseases_option.value = false;
          selectedDisease_name = '진료질환 선택';
        } else {
          isOn_diseases_option.value = true;
        }
      }, 200);
    } else {
      popupTitle.value = '진료질환 선택';
      popupDesc.value = '하위 진료질환이 없습니다. 다른 진료과목을 선택해 주세요.';
      currentPopup.value = ExceptionPopup;
    }
  }
};
const setDiseases_onSubject = (subjectCode: string) => {
  store.dispatch('moduleDr/getDiseases_onSubject', subjectCode, { root: true });
};
const onClick_subject = (item) => {
  isOn_subject_option.value = false;
  subject_result.value = item;
  selectedSubject_name = item.name;
  setDiseases_onSubject(item.code);
};
const onClick_disease_option = async (item) => {
  // console.log(item);
  // console.log(doctorInfo.value.speciality);
  // console.log(diseases_result.value);
  // reset
  isOn_diseases_option.value = false;
  // get
  if (doctorInfo.value.speciality === null) {
    doctorInfo.value.speciality = [
      {
        subject: subject_result.value,
        disease_list: [item],
      },
    ];
    regSubjectCodes.value.push(subject_result.value.code);
    diseases_result.value.push(item);
  } else {
    let reIdx = regSubjectCodes.value.indexOf(subject_result.value.code);
    if (reIdx === -1) {
      doctorInfo.value.speciality.push({
        subject: subject_result.value,
        disease_list: [item],
      });
      regSubjectCodes.value.push(subject_result.value.code);
      diseases_result.value.push(item);
    } else {
      let subDiseaseCodes = [];
      for (let j = 0; j < doctorInfo.value.speciality[reIdx].disease_list.length; j++) {
        subDiseaseCodes.push(doctorInfo.value.speciality[reIdx].disease_list[j].code);
      }
      if (subDiseaseCodes.indexOf(item.code) === -1) {
        doctorInfo.value.speciality[reIdx].disease_list.push(item);
        diseases_result.value.push(item);
      } else {
        popupTitle.value = '진료질환 선택';
        popupDesc.value = '이미 선택한 진료질환입니다.';
        currentPopup.value = ExceptionPopup;
        return;
      }
    }
  }
  // set
  setTimeout(() => {
    // console.log(doctorInfo.value.speciality); // subject_disease_dto
    checkValid_diseases();
    isOn_diseases_result.value = true;
  }, 200);
};
const setSubjects = () => {
  store.dispatch('moduleDr/getSubjects', { root: true });
};
const delete__disease_list_item = async (item) => {
  for (let i = 0; i < doctorInfo.value.speciality.length; i++) {
    for (let j = 0; j < doctorInfo.value.speciality[i].disease_list.length; j++) {
      if (doctorInfo.value.speciality[i].disease_list[j].code === item.code) {
        doctorInfo.value.speciality[i].disease_list.splice(j, 1);
      }
    }
  }
};
const onClick_disease_result_item = async (item, index) => {
  diseases_result.value.splice(index, 1);
  await delete__disease_list_item(item);
  for (let i = 0; i < doctorInfo.value.speciality.length; i++) {
    if (doctorInfo.value.speciality[i].disease_list.length === 0) {
      if (regSubjectCodes.value.indexOf(doctorInfo.value.speciality[i].subject.code) !== -1) {
        regSubjectCodes.value.splice(regSubjectCodes.value.indexOf(doctorInfo.value.speciality[i].subject.code), 1);
      }
      doctorInfo.value.speciality.splice(i, 1);
    }
  }
  checkValid_diseases();
};
const setLicenseImage_fromDoctorInfo = () => {
  licenseImage.value.name = doctorInfo.value.licenseImageName;
  licenseImage.value.size = 10;
  licenseImage.value.thumbnail = doctorInfo.value.licenseImageUrl;
  licenseImage.value.url = doctorInfo.value.licenseImageUrl;
};
const setProfileImage_fromDoctorInfo = () => {
  profileImage.value.name = doctorInfo.value.profileImageName;
  profileImage.value.size = 10;
  profileImage.value.thumbnail = doctorInfo.value.profileImageUrl;
  profileImage.value.url = doctorInfo.value.profileImageUrl;
};
const onLicenseImage = (event) => {
  var input = event.target;
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = (e) => {
      licenseImage.value.url = e.target.result;
      licenseImage.value.thumbnail = e.target.result;
    };
    reader.readAsDataURL(input.files[0]);
    doctorInfo.value.licenseImage = input.files[0];
  }
};
const onProfileImage = (event) => {
  var input = event.target;
  if (input.files && input.files[0]) {
    var reader = new FileReader();
    reader.onload = (e) => {
      profileImage.value.url = e.target.result;
      profileImage.value.thumbnail = e.target.result;
    };
    reader.readAsDataURL(input.files[0]);
    doctorInfo.value.profileImage = input.files[0];
  }
};
const changeLicenseImage = async () => {
  let maxSize = 1024 * 200;
  let file = document.getElementById('licenseImage').files[0];
  if (file.size > maxSize) {
    popupTitle.value = '면허 & 여권 사진 첨부';
    popupDesc.value = '200kb이내의 파일을 첨부해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    licenseImage.value.name = file.name;
    licenseImage.value.type = file.type;
    licenseImage.value.size = file.size;
    onLicenseImage(event);
  }
};
const changeProfileImage = async () => {
  let maxSize = 1024 * 200;
  let file = document.getElementById('profileImage').files[0];
  if (file.size > maxSize) {
    popupTitle.value = '프로필 사진 첨부';
    popupDesc.value = '200kb이내의 파일을 첨부해 주세요.';
    currentPopup.value = ExceptionPopup;
  } else {
    profileImage.value.name = file.name;
    profileImage.value.type = file.type;
    profileImage.value.size = file.size;
    onProfileImage(event);
  }
};
const checkVailid_all = () => {
  let v = isValid.value;
  if (
    v.doctorName &&
    v.doctorEmail &&
    v.metaverseUrl &&
    v.nationality &&
    v.diseases &&
    v.licenseNumber &&
    v.licenseImage &&
    v.profileImage &&
    v.affiliationEn &&
    v.activityEn &&
    v.educationEn &&
    v.affiliationKr &&
    v.activityKr &&
    v.educationKr &&
    v.affiliationRu &&
    v.activityRu &&
    v.educationRu
  ) {
    return true;
  } else {
    return false;
  }
};
const modify_default = async () => {
  let lic = null;
  let pro = null;
  if (licenseImage.value.size !== 10) {
    console.log(doctorInfo.value.licenseImage);
    lic = doctorInfo.value.licenseImage;
  }
  if (profileImage.value.size !== 10) {
    console.log(doctorInfo.value.profileImage);
    pro = doctorInfo.value.profileImage;
  }
  // alert(`${lic} / ${pro}`);
  let params = await {
    licenseImage: lic,
    licenseNumber: doctorInfo.value.licenseNumber,
    metaverseUrl: doctorInfo.value.metaverseUrl,
    nationality: doctorInfo.value.nationality,
    doctorSid: doctorInfo.value.doctorSid,
    profileImage: pro,
    diseases: doctorInfo.value.speciality,
  };
  return await store.dispatch('moduleDr/modifyDoctorInfo_default', params, { root: true });
};
const modify_en = async () => {
  let addKr = {
    physician_sid: doctorInfo.value.doctorSid,
    activity: doctorInfo.value.activityEn,
    affiliation: doctorInfo.value.affiliationEn,
    education: doctorInfo.value.educationEn,
    lang: `en`,
    name: doctorInfo.value.doctorName,
  };
  await store.dispatch('moduleDr/registDoctorInfo_add', addKr, { root: true });
};
const modify_kr = async () => {
  let addKr = {
    physician_sid: doctorInfo.value.doctorSid,
    activity: doctorInfo.value.activityKr,
    affiliation: doctorInfo.value.affiliationKr,
    education: doctorInfo.value.educationKr,
    lang: `kr`,
    name: doctorInfo.value.doctorName,
  };
  await store.dispatch('moduleDr/registDoctorInfo_add', addKr, { root: true });
};
const modify_ru = async () => {
  let addRu = {
    physician_sid: doctorInfo.value.doctorSid,
    activity: doctorInfo.value.activityRu,
    affiliation: doctorInfo.value.affiliationRu,
    education: doctorInfo.value.educationRu,
    lang: `ru`,
    name: doctorInfo.value.doctorName,
  };
  await store.dispatch('moduleDr/registDoctorInfo_add', addRu, { root: true });
};
const onClick_modify = async () => {
  let flag = await checkVailid_all();
  if (flag) {
    modify_default();
    modify_en();
    if (
      doctorInfo.value.affiliationKr !== `` ||
      doctorInfo.value.activityKr !== `` ||
      doctorInfo.value.educationKr !== `` ||
      doctorInfo.value.affiliationKr !== null ||
      doctorInfo.value.activityKr !== null ||
      doctorInfo.value.educationKr !== null
    ) {
      modify_kr();
    }
    if (
      doctorInfo.value.affiliationRu !== `` ||
      doctorInfo.value.activityRu !== `` ||
      doctorInfo.value.educationRu !== `` ||
      doctorInfo.value.affiliationRu !== null ||
      doctorInfo.value.activityRu !== null ||
      doctorInfo.value.educationRu !== null
    ) {
      modify_ru();
    }
  } else {
    popupTitle.value = '의료진 정보 수정';
    popupDesc.value = '입력 정보를 다시 확인해 주세요.';
    currentPopup.value = ExceptionPopup;
    return;
  }
};
const setVailid_all = async () => {
  checkValid_doctorName();
  checkValid_doctorEmail();
  checkValid_metaverseUrl();
  checkValid_nationality();
  checkValid_diseases();
  checkValid_licenseNumber();
  checkValid_licenseImage();
  checkValid_profileImage();
  checkValid_affiliationEn();
  checkValid_activityEn();
  checkValid_educationEn();
  checkValid_affiliationKr();
  checkValid_activityKr();
  checkValid_educationKr();
  checkValid_affiliationRu();
  checkValid_activityRu();
  checkValid_educationRu();
};
/**** content -----------------
 * 의료진 정보 조회 및 수정
 * /
 * /

/**** hook -------------------- */
onBeforeMount(() => {
  setDoctorInfo();
  setSubjects();
  setNationalityList();
});
onMounted(() => {
  setTimeout(() => {
    setLicenseImage_fromDoctorInfo();
    setProfileImage_fromDoctorInfo();
    setSubjects_result();
    setDisease_result();
    setVailid_all();
    isOnLoading_doctorInfo.value = false;
  }, 400);
});
watch(
  () => doctorInfo.value.doctorName,
  () => {
    doctorInfo.value.doctorName = doctorInfo.value.doctorName.replace(/^[\s\uFEFF\xA0]+/gi, '');
    checkValid_doctorName();
  }
);
watch(
  () => doctorInfo.value.doctorEmail,
  () => {
    doctorInfo.value.doctorEmail = doctorInfo.value.doctorEmail.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorInfo.value.doctorEmail = doctorInfo.value.doctorEmail.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_doctorEmail();
  }
);
watch(
  () => doctorInfo.value.metaverseUrl,
  (newValue) => {
    if (newValue === '') {
      doctorInfo.value.metaverseUrl = 'https://';
    }
    doctorInfo.value.metaverseUrl = doctorInfo.value.metaverseUrl.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorInfo.value.metaverseUrl = doctorInfo.value.metaverseUrl.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_metaverseUrl();
  }
);
watch(
  () => doctorInfo.value.nationality,
  () => {
    doctorInfo.value.nationality = doctorInfo.value.nationality.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorInfo.value.nationality = doctorInfo.value.nationality.replace(/\b[a-z]/, (str) => str.toUpperCase());
    checkValid_nationality();
  }
);
watch(
  () => doctorInfo.value.licenseNumber,
  () => {
    doctorInfo.value.licenseNumber = doctorInfo.value.licenseNumber.replace(/^[\s\uFEFF\xA0]+/gi, '');
    doctorInfo.value.licenseNumber = doctorInfo.value.licenseNumber.replace(/[\s\uFEFF\xA0]+$/gi, '');
    checkValid_licenseNumber();
  }
);
watch(
  () => doctorInfo.value.licenseImage,
  () => {
    checkValid_licenseImage();
  }
);
watch(
  () => doctorInfo.value.profileImage,
  () => {
    checkValid_profileImage();
  }
);
watch(
  () => doctorInfo.value.affiliationEn,
  () => {
    checkValid_affiliationEn();
  }
);
watch(
  () => doctorInfo.value.activityEn,
  () => {
    checkValid_activityEn();
  }
);
watch(
  () => doctorInfo.value.educationEn,
  (newValue: string, oldValue: string) => {
    checkValid_educationEn();
  }
);
watch(
  () => doctorInfo.value.affiliationKr,
  (newValue: string, oldValue: string) => {
    checkValid_affiliationKr();
  }
);
watch(
  () => doctorInfo.value.activityKr,
  (newValue: string, oldValue: string) => {
    checkValid_activityKr();
  }
);
watch(
  () => doctorInfo.value.educationKr,
  (newValue: string, oldValue: string) => {
    checkValid_educationKr();
  }
);
watch(
  () => doctorInfo.value.affiliationRu,
  (newValue: string, oldValue: string) => {
    checkValid_affiliationRu();
  }
);
watch(
  () => doctorInfo.value.activityRu,
  (newValue: string, oldValue: string) => {
    checkValid_activityRu();
  }
);
watch(
  () => doctorInfo.value.educationRu,
  (newValue: string, oldValue: string) => {
    checkValid_educationRu();
  }
);
// watch(
//   () => doctorInfo.value.speciality,
//   (newValue: string, oldValue: string) => {
//     setDisease_result();
//   }
// );
watch(
  () => diseases_result.value,
  (newValue: any, oldValue: any) => {
    if (newValue.length === 0) {
      isOn_diseases_result.value = false;
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (!_unref(exception).doctorInfo.bool)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (__props.currentDoctor.statusName === '승인')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createElementVNode("span", _hoisted_6, [
                    _createVNode(StatusButton, {
                      "status-name": __props.currentDoctor.statusName
                    }, null, 8, ["status-name"])
                  ]),
                  _createTextVNode(" 한 의료진입니다. ")
                ]))
              : (__props.currentDoctor.statusName === '대기')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", _hoisted_8, [
                      _createVNode(StatusButton, {
                        "status-name": __props.currentDoctor.statusName
                      }, null, 8, ["status-name"])
                    ]),
                    _createTextVNode(" 중인 의료진입니다. "),
                    _hoisted_9,
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("button", {
                        class: "btn-confirm-approve",
                        onClick: _cache[0] || (_cache[0] = ($event: any) => (onClick_approve()))
                      }, "예")
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]))
        : _createCommentVNode("", true)
    ]),
    (!_unref(isOnLoading_doctorInfo) && _unref(exception).doctorInfo.bool)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("p", {
              class: _normalizeClass([{ 'err-server-bang': _unref(exception).doctorInfo.type === 'bang' }, { 'err-server-empty': _unref(exception).doctorInfo.type === 'empty' }])
            }, null, 2),
            _createElementVNode("p", _hoisted_13, _toDisplayString(_unref(exception).doctorInfo.desc), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (!_unref(isOnLoading_doctorInfo) && !_unref(exception).doctorInfo.bool)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("section", _hoisted_15, [
            _createElementVNode("form", _hoisted_16, [
              _createElementVNode("fieldset", _hoisted_17, [
                _hoisted_18,
                _createElementVNode("div", _hoisted_19, [
                  _hoisted_20,
                  _withDirectives(_createElementVNode("input", {
                    class: "input-name",
                    type: "text",
                    name: "doctorName",
                    id: "doctorName",
                    placeholder: "이름 입력",
                    required: "true",
                    readonly: "true",
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(doctorInfo).doctorName) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(doctorInfo).doctorName]
                  ]),
                  _createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).doctorName ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).doctorName), 3)
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _withDirectives(_createElementVNode("input", {
                    class: "input-id",
                    type: "text",
                    name: "doctorEmail",
                    id: "doctorEmail",
                    placeholder: "example@email.com",
                    required: "true",
                    readonly: "true",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(doctorInfo).doctorEmail) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(doctorInfo).doctorEmail]
                  ]),
                  _withDirectives(_createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).doctorEmail ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).doctorEmail), 3), [
                    [_vShow, _unref(validMsg).doctorEmail !== ``]
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _hoisted_24,
                  _withDirectives(_createElementVNode("input", {
                    type: "search",
                    name: "metaverseUrl",
                    id: "metaverseUrl",
                    placeholder: "https://",
                    required: "true",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(doctorInfo).metaverseUrl) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(doctorInfo).metaverseUrl]
                  ]),
                  _withDirectives(_createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).metaverseUrl ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).metaverseUrl), 3), [
                    [_vShow, _unref(validMsg).metaverseUrl !== ``]
                  ])
                ]),
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    class: "input-search",
                    type: "search",
                    name: "nationality",
                    id: "nationality",
                    placeholder: "국가 검색",
                    required: "true",
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(doctorInfo).nationality) = $event)),
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (onClick_nationality_box()))
                  }, null, 512), [
                    [_vModelText, _unref(doctorInfo).nationality]
                  ]),
                  _createElementVNode("button", {
                    class: "btn-search",
                    onClick: _cache[6] || (_cache[6] = _withModifiers(() => {}, ["prevent"]))
                  }, "검색"),
                  _createVNode(_Transition, { name: "selectOption" }, {
                    default: _withCtx(() => [
                      _withDirectives(_createElementVNode("div", _hoisted_27, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(nationalityList), (item) => {
                          return (_openBlock(), _createElementBlock("ul", {
                            class: "options",
                            key: item
                          }, [
                            _withDirectives(_createElementVNode("li", {
                              class: "option-list",
                              onClick: ($event: any) => (onClick_nationality(item))
                            }, _toDisplayString(item.countryName), 9, _hoisted_28), [
                              [_vShow, item.countryName.startsWith(_unref(doctorInfo).nationality)]
                            ])
                          ]))
                        }), 128))
                      ], 512), [
                        [_vShow, _unref(isOn_nationality_option)]
                      ])
                    ]),
                    _: 1
                  }),
                  _withDirectives(_createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).nationality ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).nationality), 3), [
                    [_vShow, _unref(validMsg).nationality !== ``]
                  ])
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createElementVNode("div", {
                    class: _normalizeClass(["option-default", [{ on: _unref(isOn_subject_option) === true }, { selected: _unref(selectedSubject_name) !== '진료과목 선택' }]]),
                    onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (onClick_subjects_box()), ["prevent"]))
                  }, _toDisplayString(_unref(selectedSubject_name)), 3),
                  _createVNode(_Transition, { name: "selectOption" }, {
                    default: _withCtx(() => [
                      (_unref(isOn_subject_option))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                            _createElementVNode("ul", _hoisted_32, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(subjects), (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "option-list",
                                  key: item,
                                  onClick: ($event: any) => (onClick_subject(item))
                                }, _toDisplayString(item.name), 9, _hoisted_33))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_34, [
                  _hoisted_35,
                  _createElementVNode("div", {
                    class: _normalizeClass(["option-default", [{ on: _unref(isOn_diseases_option) === true }, { selected: _unref(selectedDisease_name) !== '진료질환 선택' }]]),
                    onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (onClick_diseases_onSubject_box()), ["prevent"]))
                  }, _toDisplayString(_unref(selectedDisease_name)), 3),
                  _createVNode(_Transition, { name: "selectOption" }, {
                    default: _withCtx(() => [
                      (_unref(isOn_diseases_option))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
                            _createElementVNode("ul", _hoisted_37, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diseases_onSubject), (item) => {
                                return (_openBlock(), _createElementBlock("li", {
                                  class: "option-list",
                                  key: item,
                                  onClick: ($event: any) => (onClick_disease_option(item))
                                }, _toDisplayString(item.name), 9, _hoisted_38))
                              }), 128))
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }),
                  (_unref(isOn_diseases_result))
                    ? (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(diseases_result), (item, index) => {
                          return (_openBlock(), _createElementBlock("li", {
                            class: "option-result-list",
                            key: item,
                            onClick: ($event: any) => (onClick_disease_result_item(item, index))
                          }, _toDisplayString(item.name), 9, _hoisted_40))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  _withDirectives(_createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).diseases ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).diseases), 3), [
                    [_vShow, _unref(validMsg).diseases !== ``]
                  ])
                ]),
                _createElementVNode("div", _hoisted_41, [
                  _hoisted_42,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    name: "licenseNumber",
                    id: "licenseNumber",
                    placeholder: "면허번호 입력",
                    required: "true",
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_unref(doctorInfo).licenseNumber) = $event))
                  }, null, 512), [
                    [_vModelText, _unref(doctorInfo).licenseNumber]
                  ]),
                  _withDirectives(_createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).licenseNumber ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).licenseNumber), 3), [
                    [_vShow, _unref(validMsg).licenseNumber !== ``]
                  ])
                ]),
                _createElementVNode("div", _hoisted_43, [
                  _hoisted_44,
                  _createElementVNode("label", _hoisted_45, [
                    _createElementVNode("div", _hoisted_46, [
                      _createElementVNode("span", _hoisted_47, [
                        (_unref(licenseImage).size !== 0)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: _unref(licenseImage).thumbnail,
                              alt: "썸네일"
                            }, null, 8, _hoisted_48))
                          : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["file-name", [{ on: _unref(licenseImage).size !== 0 }]])
                      }, _toDisplayString(_unref(licenseImage).name), 3)
                    ]),
                    _hoisted_49
                  ]),
                  _createElementVNode("input", {
                    class: "input-file",
                    type: "file",
                    name: "licenseImage",
                    id: "licenseImage",
                    placeholder: ".gif, .jpeg, .png (200mb 이하)",
                    accept: "image/gif, image/jpeg, image/png",
                    onChange: _cache[10] || (_cache[10] = ($event: any) => (changeLicenseImage()))
                  }, null, 32),
                  _createElementVNode("div", _hoisted_50, [
                    (_unref(licenseImage).size !== 0)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(licenseImage).url,
                          alt: "면허 여권 사진 미리보기"
                        }, null, 8, _hoisted_51))
                      : _createCommentVNode("", true),
                    (_unref(licenseImage).thumbnail === ``)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_52, "미리보기"))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).licenseImage ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).licenseImage), 3), [
                    [_vShow, _unref(validMsg).licenseImage !== ``]
                  ])
                ]),
                _createElementVNode("div", _hoisted_53, [
                  _hoisted_54,
                  _createElementVNode("label", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _createElementVNode("span", _hoisted_57, [
                        _withDirectives(_createElementVNode("img", {
                          src: _unref(profileImage).thumbnail,
                          alt: "썸네일"
                        }, null, 8, _hoisted_58), [
                          [_vShow, _unref(profileImage).size !== 0]
                        ])
                      ]),
                      _createElementVNode("span", {
                        class: _normalizeClass(["file-name", [{ on: _unref(profileImage).size !== 0 }]])
                      }, _toDisplayString(_unref(profileImage).name), 3)
                    ]),
                    _hoisted_59
                  ]),
                  _createElementVNode("input", {
                    class: "input-file",
                    type: "file",
                    name: "profileImage",
                    id: "profileImage",
                    placeholder: ".gif, .jpeg, .png (200mb 이하)",
                    accept: "image/gif, image/jpeg, image/png",
                    onChange: _cache[11] || (_cache[11] = ($event: any) => (changeProfileImage()))
                  }, null, 32),
                  _createElementVNode("div", _hoisted_60, [
                    (_unref(profileImage).size !== 0)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          src: _unref(profileImage).url,
                          alt: "의료진 프로필 사진 미리보기"
                        }, null, 8, _hoisted_61))
                      : _createCommentVNode("", true),
                    (_unref(profileImage).thumbnail === ``)
                      ? (_openBlock(), _createElementBlock("p", _hoisted_62, "미리보기"))
                      : _createCommentVNode("", true)
                  ]),
                  _withDirectives(_createElementVNode("p", {
                    class: _normalizeClass([_unref(isValid).profileImage ? 'valid-msg-ok' : 'valid-msg'])
                  }, _toDisplayString(_unref(validMsg).profileImage), 3), [
                    [_vShow, _unref(validMsg).profileImage !== ``]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_63, [
            _createElementVNode("section", _hoisted_64, [
              _createElementVNode("div", _hoisted_65, [
                _createElementVNode("button", {
                  class: _normalizeClass(["lang-tab-kr", [{ on: _unref(isOn_tabKr) }]]),
                  onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_unref(onClick_tabKr)()), ["prevent"]))
                }, "한국어", 2),
                _createElementVNode("button", {
                  class: _normalizeClass(["lang-tab-ru", [{ on: _unref(isOn_tabRu) }]]),
                  onClick: _cache[13] || (_cache[13] = _withModifiers(($event: any) => (_unref(onClick_tabRu)()), ["prevent"]))
                }, "러시아어", 2)
              ]),
              _createElementVNode("div", _hoisted_66, [
                _createElementVNode("form", _hoisted_67, [
                  _createElementVNode("fieldset", _hoisted_68, [
                    _hoisted_69,
                    _hoisted_70,
                    _createElementVNode("div", _hoisted_71, [
                      _hoisted_72,
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        name: "affiliationEn",
                        id: "affiliationEn",
                        placeholder: "소속을 영어로 입력해 주세요.",
                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(doctorInfo).affiliationEn) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(doctorInfo).affiliationEn]
                      ]),
                      _withDirectives(_createElementVNode("p", {
                        class: _normalizeClass([_unref(isValid).affiliationEn ? 'valid-msg-ok' : 'valid-msg'])
                      }, _toDisplayString(_unref(validMsg).affiliationEn), 3), [
                        [_vShow, _unref(validMsg).affiliationEn !== ``]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_73, [
                      _hoisted_74,
                      _withDirectives(_createElementVNode("textarea", {
                        cols: "50",
                        rows: "60",
                        name: "activityEn",
                        id: "activityEn",
                        placeholder: "학술활동/언론보도 내용을 영어로 입력해 주세요.",
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(doctorInfo).activityEn) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(doctorInfo).activityEn]
                      ]),
                      _withDirectives(_createElementVNode("p", {
                        class: _normalizeClass([_unref(isValid).activityEn ? 'valid-msg-ok' : 'valid-msg'])
                      }, _toDisplayString(_unref(validMsg).activityEn), 3), [
                        [_vShow, _unref(validMsg).activityEn !== ``]
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_75, [
                      _hoisted_76,
                      _withDirectives(_createElementVNode("textarea", {
                        cols: "50",
                        rows: "60",
                        name: "educationEn",
                        id: "educationEn",
                        placeholder: "학력/경력 사항을 영어로 입력해 주세요.",
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(doctorInfo).educationEn) = $event))
                      }, null, 512), [
                        [_vModelText, _unref(doctorInfo).educationEn]
                      ]),
                      _withDirectives(_createElementVNode("p", {
                        class: _normalizeClass([_unref(isValid).educationEn ? 'valid-msg-ok' : 'valid-msg'])
                      }, _toDisplayString(_unref(validMsg).educationEn), 3), [
                        [_vShow, _unref(validMsg).educationEn !== ``]
                      ])
                    ])
                  ])
                ])
              ]),
              (_unref(isOn_tabKr))
                ? (_openBlock(), _createElementBlock("div", _hoisted_77, [
                    _createElementVNode("fieldset", _hoisted_78, [
                      _hoisted_79,
                      _createElementVNode("div", _hoisted_80, [
                        _hoisted_81,
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          name: "affiliationKr",
                          id: "affiliationKr",
                          placeholder: "소속을 한국어로 입력해 주세요.",
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_unref(doctorInfo).affiliationKr) = $event))
                        }, null, 512), [
                          [_vModelText, _unref(doctorInfo).affiliationKr]
                        ]),
                        _createElementVNode("p", {
                          class: _normalizeClass([_unref(isValid).affiliationKr ? 'valid-msg-ok' : 'valid-msg'])
                        }, _toDisplayString(_unref(validMsg).affiliationKr), 3)
                      ]),
                      _createElementVNode("div", _hoisted_82, [
                        _hoisted_83,
                        _withDirectives(_createElementVNode("textarea", {
                          cols: "50",
                          rows: "60",
                          id: "achivementKr",
                          placeholder: "학술활동/언론보도 내용을 한국어로 입력해 주세요.",
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(doctorInfo).activityKr) = $event))
                        }, null, 512), [
                          [_vModelText, _unref(doctorInfo).activityKr]
                        ]),
                        _createElementVNode("p", {
                          class: _normalizeClass([_unref(isValid).activityKr ? 'valid-msg-ok' : 'valid-msg'])
                        }, _toDisplayString(_unref(validMsg).activityKr), 3)
                      ]),
                      _createElementVNode("div", _hoisted_84, [
                        _hoisted_85,
                        _withDirectives(_createElementVNode("textarea", {
                          cols: "50",
                          rows: "60",
                          id: "educationKr",
                          placeholder: "학력/경력 사항을 한국어로 입력해 주세요.",
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_unref(doctorInfo).educationKr) = $event))
                        }, null, 512), [
                          [_vModelText, _unref(doctorInfo).educationKr]
                        ]),
                        _createElementVNode("p", {
                          class: _normalizeClass([_unref(isValid).educationKr ? 'valid-msg-ok' : 'valid-msg'])
                        }, _toDisplayString(_unref(validMsg).educationKr), 3)
                      ])
                    ])
                  ]))
                : (_unref(isOn_tabRu))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_86, [
                      _createElementVNode("form", _hoisted_87, [
                        _createElementVNode("fieldset", _hoisted_88, [
                          _hoisted_89,
                          _createElementVNode("div", _hoisted_90, [
                            _hoisted_91,
                            _withDirectives(_createElementVNode("input", {
                              type: "text",
                              name: "affiliationRu",
                              id: "affiliationRu",
                              placeholder: "소속을 러시아어로 입력해 주세요.",
                              "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(doctorInfo).affiliationRu) = $event))
                            }, null, 512), [
                              [_vModelText, _unref(doctorInfo).affiliationRu]
                            ]),
                            _createElementVNode("p", {
                              class: _normalizeClass([_unref(isValid).affiliationRu ? 'valid-msg-ok' : 'valid-msg'])
                            }, _toDisplayString(_unref(validMsg).affiliationRu), 3)
                          ]),
                          _createElementVNode("div", _hoisted_92, [
                            _hoisted_93,
                            _withDirectives(_createElementVNode("textarea", {
                              cols: "50",
                              rows: "60",
                              id: "activityRu",
                              placeholder: "학술활동/언론보도 내용을 러시아어로 입력해 주세요.",
                              "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_unref(doctorInfo).activityRu) = $event))
                            }, null, 512), [
                              [_vModelText, _unref(doctorInfo).activityRu]
                            ]),
                            _createElementVNode("p", {
                              class: _normalizeClass([_unref(isValid).activityRu ? 'valid-msg-ok' : 'valid-msg'])
                            }, _toDisplayString(_unref(validMsg).activityRu), 3)
                          ]),
                          _createElementVNode("div", _hoisted_94, [
                            _hoisted_95,
                            _withDirectives(_createElementVNode("textarea", {
                              cols: "50",
                              rows: "60",
                              id: "educationRu",
                              placeholder: "학력/경력 사항을 러시아어로 입력해 주세요.",
                              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(doctorInfo).educationRu) = $event))
                            }, null, 512), [
                              [_vModelText, _unref(doctorInfo).educationRu]
                            ]),
                            _createElementVNode("p", {
                              class: _normalizeClass([_unref(isValid).educationRu ? 'valid-msg-ok' : 'valid-msg'])
                            }, _toDisplayString(_unref(validMsg).educationRu), 3)
                          ])
                        ])
                      ])
                    ]))
                  : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_Transition, { name: "currentPopup" }, {
            default: _withCtx(() => [
              (_unref(currentPopup) !== null)
                ? (_openBlock(), _createElementBlock("div", _hoisted_96, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(currentPopup)), {
                      "popup-title": _unref(popupTitle),
                      "popup-desc": _unref(popupDesc),
                      onOnClick_close: _cache[23] || (_cache[23] = ($event: any) => (onClick_close())),
                      onOnClick_cancel: _cache[24] || (_cache[24] = ($event: any) => (onClick_cancel())),
                      onOnClick_confirm: _cache[25] || (_cache[25] = ($event: any) => (onClick_confirm()))
                    }, null, 40, ["popup-title", "popup-desc"]))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_Transition, { name: "resultPopup" }, {
            default: _withCtx(() => [
              (_unref(result).bool)
                ? (_openBlock(), _createElementBlock("div", _hoisted_97, [
                    _createVNode(ResultPopup, {
                      "result-title": _unref(result).title,
                      "result-desc": _unref(result).desc,
                      onOnClick_close: _cache[26] || (_cache[26] = ($event: any) => (close_resultPopup()))
                    }, null, 8, ["result-title", "result-desc"])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    (_unref(isOnLoading_doctorInfo))
      ? (_openBlock(), _createElementBlock("div", _hoisted_98, _hoisted_100))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_101, [
      _createElementVNode("div", _hoisted_102, [
        _createElementVNode("button", {
          class: "btn btn-type-1",
          onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.$emit('onClick_close')))
        }, "취소"),
        _createElementVNode("button", {
          class: "btn btn-type-2",
          onClick: _cache[28] || (_cache[28] = _withModifiers(($event: any) => (onClick_modify()), ["prevent"]))
        }, "수정")
      ])
    ])
  ]))
}
}

})